/**
 * Abdominal Examination Data Points
 * Category: Abdomen
 */

export const abdomenDataPoints = [
  // Inspection
  {
    id: 'inspection',
    label: 'Inspection',
    category: 'Abdomen',
    subcategory: 'Physical Examination',
    fieldType: 'multi',
    isActive: true,
    options: ['Normal', 'Distended', 'Other'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: true,
      required: false,
      defaultValue: null,
      placeholder: 'Specify other inspection findings...',
      helpText: 'Visual inspection of abdomen'
    },
    code: '5880005', // SNOMED CT - Physical examination procedure
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Bowel Sounds
  {
    id: 'bowel_sounds',
    label: 'Bowel sounds',
    category: 'Abdomen',
    subcategory: 'Physical Examination',
    fieldType: 'multi',
    isActive: true,
    options: ['Normal', 'Increased', 'Decreased'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Auscultation of bowel sounds'
    },
    code: '162062003', // SNOMED CT - Bowel sounds
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Percussion
  {
    id: 'percussion',
    label: 'Percussion',
    category: 'Abdomen',
    subcategory: 'Physical Examination',
    fieldType: 'multi',
    isActive: true,
    options: ['Normal', 'Dullness', 'Other'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: true,
      required: false,
      defaultValue: null,
      placeholder: 'Specify other percussion findings...',
      helpText: 'Percussion findings of abdomen'
    },
    code: '37931006', // SNOMED CT - Percussion
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Palpation
  {
    id: 'palpation',
    label: 'Palpation',
    category: 'Abdomen',
    subcategory: 'Physical Examination',
    fieldType: 'multi',
    isActive: true,
    options: ['Non-tender', 'Guarding', 'Tenderness'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Palpation findings of abdomen'
    },
    code: '113011001', // SNOMED CT - Palpation
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Rebound Tenderness
  {
    id: 'rebound_tenderness',
    label: 'Rebound tenderness',
    category: 'Abdomen',
    subcategory: 'Physical Examination',
    fieldType: 'multi',
    isActive: true,
    options: ['No', 'Yes'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Check for rebound tenderness'
    },
    code: '89723001', // SNOMED CT - Rebound tenderness
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Renal Angle Tenderness
  {
    id: 'renal_angle_tenderness',
    label: 'Renal angle tenderness',
    category: 'Abdomen',
    subcategory: 'Physical Examination',
    fieldType: 'multi',
    isActive: true,
    options: ['No', 'Yes'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Check for costovertebral angle tenderness'
    },
    code: '424124008', // SNOMED CT - Renal angle tenderness
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Last Normal Menstrual Period (LNMP)
  {
    id: 'lnmp',
    label: 'Last normal menstrual period (LNMP)',
    category: 'Abdomen',
    subcategory: 'Gynecological History',
    fieldType: 'text',
    isActive: true,
    options: [],
    default: '',
    inputConfig: {
      inputType: 'text',
      multiSelect: false,
      allowOther: false,
      required: false,
      defaultValue: '',
      placeholder: 'Enter date of last normal menstrual period...',
      helpText: 'Date of last normal menstrual period (relevant for female patients)'
    },
    code: '21840007', // SNOMED CT - Date of last menstrual period
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },

  // Pregnancy Test
  {
    id: 'pregnancy_test',
    label: 'Pregnancy test',
    category: 'Abdomen',
    subcategory: 'Gynecological History',
    fieldType: 'multi',
    isActive: true,
    options: ['Not indicated', 'Positive', 'Negative'],
    default: [],
    inputConfig: {
      inputType: 'checkbox',
      multiSelect: true,
      allowOther: false,
      required: false,
      defaultValue: null,
      placeholder: '',
      helpText: 'Pregnancy test results (if applicable)'
    },
    code: '252160004', // SNOMED CT - Pregnancy test
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  }
]

export default abdomenDataPoints
